export default "__VITE_ASSET__DyDNvS1b__"